<template>
  <div>
    <ts-card>
      <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
        <h4 class="ts-text-sm">{{ $t('restaurantSale.combineTable') }}</h4>
      </div>
    </ts-card>
    <ts-card-wrapper>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="required">{{ $t('restaurantSale.fromTable') }}</label>
            <treeselect :options="fromTables.map(el => ({
              table_id: el.table_id,
              id: el.stock_out_id,
              label: 'Table: ' + el.table_no + ' | Order: #' + el.order_no
            }))
              " :placeholder="$t('select')" v-model="model.stock_out_from_id"
              @select="value => (model.table_from_id = value.table_id)" @input="onChangeFromTable" />
            <div class="validate" v-if="errors.has('stock_out_from_id')">
              {{ errors.first('stock_out_from_id') }}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label class="required">{{ $t('restaurantSale.toTable') }}</label>
            <treeselect :options="toTables.map(el => ({
              table_id: el.table_id,
              id: el.stock_out_id,
              label: 'Table: ' + el.table_no + ' | Order: #' + el.order_no
            }))
              " :placeholder="$t('select')" v-model="model.stock_out_to_id"
              :disabled="!model.table_from_id ? true : false" @select="value => (table_to_id = value.table_id)"
              @input="onChangeToTable" />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <div id="container-table">
              <table v-if="fromTableSelected"
                class="table table-bordered widget-table widget-table-rounded inverse-mode">
                <thead>
                  <tr>
                    <th>{{ $t('restaurantSale.photo') }}</th>
                    <th>{{ $t('restaurantSale.product') }}</th>
                    <th>{{ $t('restaurantSale.price') }}</th>
                    <th>{{ $t('restaurantSale.qty') }}</th>
                    <th>{{ $t('restaurantSale.discount') }}</th>
                    <th>{{ $t('restaurantSale.total') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in fromTableSelected.invoice_detail" :key="index">
                    <td>
                      <img class="widget-table-img" v-lazy="{
                        src: productPhoto(item),
                        error: require('@/assets/default-product.jpg'),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }" />
                    </td>
                    <td>
                      <h4 class="widget-table-title">
                        {{ item.product_name_en }}
                      </h4>
                      <p class="widget-table-desc m-b-15">
                        {{ item.product_name_kh }}
                      </p>
                      <small :class="cookingStatus(item.cooking_status_id)"><i class="fas fa-mortar-pestle"></i>
                        {{ item.cooking_status }}</small>
                      <div class="clearfix f-s-10"></div>
                    </td>
                    <td class="text-nowrap">
                      <b class="text-white">{{ defaultCrrency }} {{ item.unit_price }}</b>
                    </td>
                    <td>{{ item.quantity }}</td>
                    <td>
                      {{
                        item.discount_rate
                          ? '(' + item.discount_rate + '%) => '
                          : ''
                      }}
                      {{ defaultCrrency }}
                      {{ item.discount_amount }}
                    </td>
                    <td>{{ defaultCrrency }} {{ item.grand_total }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="form-group">
              <ts-checkbox v-model="model.is_clean_from_table">{{
                $t('restaurantSale.isCleanFromTable')
              }}</ts-checkbox>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <div id="container-table">
              <table v-if="toTableSelected" class="table table-bordered widget-table widget-table-rounded inverse-mode">
                <thead>
                  <tr>
                    <th>{{ $t('restaurantSale.photo') }}</th>
                    <th>{{ $t('restaurantSale.product') }}</th>
                    <th>{{ $t('restaurantSale.price') }}</th>
                    <th>{{ $t('restaurantSale.qty') }}</th>
                    <th>{{ $t('restaurantSale.discount') }}</th>
                    <th>{{ $t('restaurantSale.total') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in toTableSelected.invoice_detail" :key="index">
                    <td>
                      <img class="widget-table-img" v-lazy="{
                        src: productPhoto(item),
                        error: require('@/assets/default-product.jpg'),
                        loading: require('@/assets/Rolling-1s-200px_2.svg')
                      }" />
                    </td>
                    <td>
                      <h4 class="widget-table-title">
                        {{ item.product_name_en }}
                      </h4>
                      <p class="widget-table-desc m-b-15">
                        {{ item.product_name_kh }}
                      </p>
                      <small :class="cookingStatus(item.cooking_status_id)"><i class="fas fa-mortar-pestle"></i>
                        {{ item.cooking_status }}</small>
                      <div class="clearfix f-s-10"></div>
                    </td>
                    <td class="text-nowrap">
                      <b class="text-white">{{ defaultCrrency }} {{ item.unit_price }}</b>
                    </td>
                    <td>{{ item.quantity }}</td>
                    <td>
                      {{
                        item.discount_rate
                          ? '(' + item.discount_rate + '%) => '
                          : ''
                      }}
                      {{ defaultCrrency }}
                      {{ item.discount_amount }}
                    </td>
                    <td>{{ defaultCrrency }} {{ item.grand_total }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right">
          <ts-button @click="$emit('close')" class="mr-2">{{
            $t('cancel')
          }}</ts-button>
          <ts-button color="primary" :waiting="waiting" @click.prevent="combine">{{ $t('restaurantSale.combine')
          }}</ts-button>
        </div>
      </div>
    </ts-card-wrapper>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'combineTable',
  data() {
    return {
      model: {
        stock_out_from_id: null,
        stock_out_to_id: null,
        table_from_id: null,
        is_clean_from_table: true
      },
      waiting: false,
      table_to_id: null,
      fromTableSelected: {},
      toTableSelected: {},
      errors: new Errors()
    }
  },
  created() {
    this.model.stock_out_from_id = this.tableSelected.stock_out_id
    this.model.table_from_id = this.tableSelected.table_id
    this.onChangeFromTable()
  },
  computed: {
    tableSelected() {
      return this.$store.state.restaurantSale.counterCheckout.tableSelected
    },
    fromTables() {
      return _.sortBy(
        this.$store.state.restaurantSale.counterCheckout.tables.filter(
          t => t.status_id == 3 && t.ref_customer_member_card_id == null
        ),
        ['display_order']
      )
    },
    toTables() {
      return _.sortBy(
        this.$store.state.restaurantSale.counterCheckout.tables.filter(
          t => t.status_id == 3 && t.table_id != this.model.table_from_id && t.ref_customer_member_card_id == null
        ),
        ['display_order']
      )
    },
    vatRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.vat_rate
      )
    },
    exchangeRate() {
      return parseFloat(
        this.$store.state.restaurantSale.customerOrder.systemSettings.fx_rate
      )
    },
    defaultCrrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .default_currency
    },
    toCurrency() {
      return this.$store.state.restaurantSale.customerOrder.systemSettings
        .to_currency
    }
  },
  methods: {
    onChangeFromTable() {
      this.model.stock_out_to_id = null
      this.fromTableSelected = this.$store.state.restaurantSale.counterCheckout.tables
        .filter(t => t.table_id == this.model.table_from_id)
        .reduce((init, value) => (init = value), {})
    },
    onChangeToTable() {
      this.toTableSelected = this.$store.state.restaurantSale.counterCheckout.tables
        .filter(t => t.stock_out_id == this.model.stock_out_to_id)
        .reduce((init, value) => (init = value), {})
    },
    cookingStatus(cooking_status_id) {
      if (cooking_status_id == 1) {
        return 'text-info'
      }
      if (cooking_status_id == 2) {
        return 'text-primary'
      }
      if (cooking_status_id == 3) {
        return 'text-success'
      }
      return 'text-danger'
    },
    combine() {
      this.waiting = true
      this.$store
        .dispatch('restaurantSale/counterCheckout/combineTable', this.model)
        .then(async response => {
          await this.$store
            .dispatch('restaurantSale/counterCheckout/fetchTables')
          this.$toasted.success(response.messages)
          this.$store.commit(
            'restaurantSale/counterCheckout/RECEIVE_TABLE_SELECTED',
            this.$store.state.restaurantSale.counterCheckout.tables
              .filter(t => t.table_id == this.table_to_id)
              .reduce((init, value) => (init = value), {})
          )
          this.$emit('close')
        })
        .catch(error => {
          this.$toasted.error(error.messages)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    productPhoto(item) {
      if (item.photo === null) return ''

      return `/api/files?filePath=${item.photo}`
    }
  }
}
</script>

<style lang="css" scoped>
#container-table {
  min-height: 30vh;
  max-height: 60vh;
  overflow-y: scroll;
  overflow-x: scroll;
}

.table>thead>tr>th,
.table>tbody>tr>th,
.table>tfoot>tr>th,
.table>thead>tr>td,
.table>tbody>tr>td,
.table>tfoot>tr>td {
  border-color: #e2e7eb;
  padding: 2px 5px;
}

.table th,
.table td {
  padding: 0.75rem;
}

.table th,
.table td {
  padding: 5px;
}
</style>
